import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils";
import { formatUserLifecycleSuffix, resolveUserLifecycle } from "../../../utils/deleted-entity-utils";
/**
 * Suffix tone per lifecycle state. Suspended reads as a firm marker;
 * inactive/pending are a gentle "not activated yet" reminder, so they get the
 * lighter tone. The deleted suffix is muted too — its row is additionally
 * grayed by `DELETED_ENTITY_CLASS`.
 */ const USER_LIFECYCLE_SUFFIX_CLASS = {
    deleted: "text-muted-foreground",
    suspended: "text-muted-foreground",
    inactive: "text-muted-foreground/70",
    pending: "text-muted-foreground/70"
};
/**
 * The one way to render a user's display name: the name in its inherited
 * style, plus the localized lifecycle marker — "(deleted)", "(suspended)",
 * "(inactive)", "(pending)" — as a muted suffix. Name and suffix share a
 * single wrapper element on purpose: flex parents with a gap (`ItemTitle`)
 * must keep seeing one child.
 */ export function UserName({ name, user, lifecycle, className }) {
    const { t } = useTranslation();
    const resolved = lifecycle !== undefined ? lifecycle : resolveUserLifecycle(user);
    return /*#__PURE__*/ _jsxs("span", {
        className: className,
        children: [
            name,
            resolved && /*#__PURE__*/ _jsx("span", {
                className: cn("font-normal", USER_LIFECYCLE_SUFFIX_CLASS[resolved]),
                children: formatUserLifecycleSuffix(resolved, t)
            })
        ]
    });
}

//# sourceMappingURL=user-name.js.map